import React, { useCallback, useState, memo, useEffect } from "react";
import _ from "lodash";
import {
  Typography,
  Menu,
  MenuItem,
  AppBar,
  Paper,
  Stack,
  IconButton,
  Avatar,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { getDadosUsuario } from "../redux/actions";
import { PainelCores } from "./header";
//
import Logo from "../imagens/logo_vermelha.svg";
import LogoBranca from "../imagens/logo_branca.svg";

import DarkModeIcon from "@mui/icons-material/DarkMode";
import LightModeIcon from "@mui/icons-material/LightMode";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import LogoutIcon from "@mui/icons-material/Logout";
import BuildIcon from "@mui/icons-material/Build";
import { useHistory } from "react-router-dom";
import { BotaoIcone } from "./index";
//
const selectUsuario = (state) => state?.usuario;

const sxStyle = {
  display: "flex",
  justifyContent: "space-between",
  height: "100%",
  alignItems: "center",
  borderRadius: "30px 0px 0px",
  px: 2,
};

function HeaderMobile({ darkMode, handleDarkMode }) {
  const dispatch = useDispatch();
  const history = useHistory();
  //
  useEffect(() => {
    dispatch(getDadosUsuario());
  }, [dispatch]);
  //
  const usuario = useSelector(selectUsuario);
  const [exibir, setExibir] = useState(null);
  // Para exibir o menu (icone que quando clicado exibe o menu)
  const exibirSubMenu = (evt) => {
    setExibir(evt.currentTarget);
  };
  // Ocultar o menu
  const ocultarSubMenu = () => {
    setExibir(null);
  };
  // Funcao para retornar
  const fnRetornar = useCallback(() => history.goBack(), [history]);
  //
  return (
    <AppBar
      position="sticky"
      variant="elevation"
      sx={{ width: "100vw", overflowX: "auto", height: 56 }}
      color="primary"
    >
      <Stack
        sx={{ height: "100%" }}
        direction="row"
        justifyContent="space-between"
        alignItems="center"
      >
        <Stack flex={4} sx={{ mx: 0.5 }} direction="row">
          {history?.action === "PUSH" && (
            <BotaoIcone
              onClick={fnRetornar}
              sx={{ color: "primary.contrastText" }}
              icone="ArrowBack"
            />
          )}
        </Stack>
        <Paper sx={sxStyle}>
          <img
            alt="Logo Empresa"
            src={darkMode ? LogoBranca : Logo}
            height={24}
          />
          <PainelCores />

          <Avatar
            title={`Olá ${usuario?.nome}`}
            src={usuario?.avatar && usuario.avatar["64x64"]}
            sx={{ mx: 1 }}
            alt={_.toUpper(usuario?.nome)}
          />
          <IconButton
            title="Alterar entre modos claro e escuro"
            sx={{ mx: 0.5 }}
            onClick={handleDarkMode}
          >
            {darkMode ? <DarkModeIcon /> : <LightModeIcon />}
          </IconButton>
          <IconButton onClick={exibirSubMenu}>
            <MoreVertIcon />
          </IconButton>
        </Paper>
      </Stack>
      <MenuAuxiliar exibir={exibir} ocultarSubMenu={ocultarSubMenu} />
    </AppBar>
  );
}

const MenuAuxiliar = ({ exibir, ocultarSubMenu }) => {
  const history = useHistory();
  //
  const subMenu = [
    {
      titulo: "Configuraçoes do usuario",
      texto: "Configurações",
      icone: <BuildIcon />,
      fn: () => {
        history.push("/configuracoes");
      },
      desabilitado: false,
    },
    {
      titulo: "Sair do App",
      texto: "Sair",
      icone: <LogoutIcon />,
      fn: () => {
        window.location.href = "/logout";
      },
      desabilitado: false,
    },
  ];
  return (
    <Menu
      variant="selectedMenu"
      open={Boolean(exibir)}
      onClose={ocultarSubMenu}
      anchorEl={exibir}
    >
      {subMenu?.map((ele, idx) => (
        <MenuItem disabled={ele.desabilitado} key={idx} onClick={ele.fn}>
          {ele.icone}
          <Typography onClick={ocultarSubMenu}>{ele.texto}</Typography>
        </MenuItem>
      ))}
    </Menu>
  );
};

export default memo(HeaderMobile);
